import { ReactionsOnMessageContainer } from './ReactionsOnMessageContainer';
import { observer } from 'mobx-react-lite';
import { ClientItemId } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import * as React from 'react';
import Message from 'owa-service/lib/contract/Message';
import { FocusZone, FocusZoneDirection } from '@fluentui/react/lib/FocusZone';

const styles = require('./ReactionsContainer.scss');
const classNames = require('classnames');

export interface ReactionsContainerProps {
    conversationId: ClientItemId;
    itemId: ClientItemId;
    item: ClientItem;
    instrumentationContext: InstrumentationContext;
    isInCollapsedRP?: boolean;
}

export const ReactionsContainer = observer(function ReactionsContainer(
    props: ReactionsContainerProps
) {
    const message = props.item as Message;
    if (!message.Reactions || props.itemId?.mailboxInfo?.type === 'GroupMailbox') {
        return null;
    }

    const containerStyle = classNames(
        styles.reactionsContainer,
        props.isInCollapsedRP && styles.reactionsContainerCollapsedRP
    );

    return (
        <div className={containerStyle}>
            <FocusZone direction={FocusZoneDirection.horizontal}>
                <ReactionsOnMessageContainer
                    message={message}
                    conversationId={props.conversationId}
                    itemId={props.itemId}
                    instrumentationContext={props.instrumentationContext}
                    isInCollapsedRP={props.isInCollapsedRP}
                />
            </FocusZone>
        </div>
    );
});
